<template>
  <el-card>
    <template #header>
      <content-header>
        公告管理
      </content-header>
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <button-link
          type="success"
          :to="link"
        >
          <slot>添加公告</slot>
        </button-link>
      </div>
    </div>

    <el-table
      :data="announcements"
      resource="announcements"
    >
      <el-table-column
        prop="title"
        label="标题"
      />
      <el-table-column
        prop="description"
        label="描述"
      />
      <el-table-column
        prop="area_name"
        label="投放区域"
      />

      <el-table-column
        label="是否有效"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status == 1"
            type="success"
          >有效</el-tag>
          <el-tag
            v-else
            type="danger"
          >无效</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="expiration_time"
        label="过期时间"
        width="180"
      />
      <el-table-column
        label="操作"
        width="300"
      >
        <template #default="{  }">
          <row-to-edit />
          <row-destroy />
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>
<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getAnnouncements } from "@/api/announcements";
import { getAreas } from "@/api/area";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
// import RowAddParking from './components/RowAddParking'

export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "投放区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "title",
          label: "标题"
        }
      ],
      announcements: [],
      page: null,
      advertisement_position: [],
      advertisement_type: [],
      first_blood: true
    };
  },
  mixins: [mixinsAutoPageSize],

  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);

        const {
          data: { data, meta }
        } = await getAnnouncements(newVal.query);
        this.announcements = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  methods: {
    addAdvertisement() {
      console.log(111);
    }
  },
  computed: {
    link() {
      // this.checkResourceName()
      // console.log(this.identify)
      return `/announcements/create`;
    }
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.search[0].options.push.apply(this.search[0].options, areas);
    // console.log(this.advertisement_position)
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[2].options.push.apply(
          this.search[2].options,
          merchant.data
        );
      }
    }
  }
};
</script>

<style lang="scss">
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
